export function isInteractiveTableTarget(target: EventTarget | null): boolean {
  if (!(target instanceof Element)) {
    return false;
  }

  if (target.closest('[data-table-interactive="true"]')) {
    return true;
  }

  const interactiveSelector = [
    'button',
    'a[href]',
    'input',
    'select',
    'textarea',
    '[role="button"]',
    '[role="link"]',
    '[role="checkbox"]',
    '[role="menu"]',
    '[role="menuitem"]',
    '[role="switch"]',
    '[role="option"]',
    '[contenteditable="true"]',
  ].join(',');

  return Boolean(target.closest(interactiveSelector));
}